export default __webpack_public_path__ + "static/media/WP-Scheduled-Posts-Is-Rebranding-Changes-Name-to-SchedulePress 1.2b2b5c79.svg";